import { render, staticRenderFns } from "./PostgresIssues.vue?vue&type=template&id=76bb363e&scoped=true"
import script from "./PostgresIssues.vue?vue&type=script&lang=js"
export * from "./PostgresIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb363e",
  null
  
)

export default component.exports